import { apiFetch } from '../../common/api/apiFetchClient';
import { isAllSaversPortal } from '../../auth/AuthContext';

export interface PolicySummary {
  surveyId: number | null;
  employerGroupName: string | null;
  employerGroupEIN: string | null;
  policyNumber: string | null;
  medIdCardNum: string | null;
  fundingType: string | null;
  surveyStatus: string | null;
  surveyYear: string | null;
  customerNumber: string | null;
  surveyStartDate: string | null;
  surveyCompletedDate: string | null;
  userName: string | null;
}

export interface QuestionType {
  questionTypeId: number;
  questionTypeName: string;
}

export async function getHistoricalPoliciesByPolicyIds(args: {
  policyIds: string[];
  portal?: string;
}): Promise<PolicySummary[]> {
  const endpoint = isAllSaversPortal(args.portal)
    ? '/api/rfi/policy/policies/allsavers?origin=history'
    : '/api/rfi/policy/policies?origin=history';
  return apiFetch<PolicySummary[]>(
    endpoint,
    {
      method: 'POST',
      body: JSON.stringify({ policyIds: args.policyIds }),
      timeoutMs: 15_000,
    }
  );
}

export async function searchHistoricalPoliciesBySearchId(args: {
  searchId: string;
  surveyYear?: string;
}): Promise<PolicySummary[]> {
  const searchId = args.searchId.trim();
  if (!searchId) {
    return [];
  }

  const surveyYear = args.surveyYear?.trim();

  const params = new URLSearchParams({ origin: 'history' });
  if (surveyYear) {
    params.set('surveyYear', surveyYear);
  }

  return apiFetch<PolicySummary[]>(
    `/api/rfi/policy/search/${encodeURIComponent(searchId)}?${params.toString()}`,
    {
      method: 'GET',
      timeoutMs: 15_000,
    }
  );
}

export async function getAllQuestionType(): Promise<QuestionType[]> {
  return apiFetch<QuestionType[]>(
    '/api/rfi/questions/getAllQuestionType',
    {
      method: 'GET',
      timeoutMs: 15_000,
    }
  );
}
